import { Injectable } from '@angular/core';
import { FormBaseInputsService } from './common/form-base-inputs.service';
import { AcmicService, FormBase, TextBox } from '@mapfre-design-library/src/public_api';
import { Constants } from '@models/constants';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class BillingStuffService {
  private enrollData = new BehaviorSubject<any>(null);

  constructor(
    private http: HttpClient,
    private fbs: FormBaseInputsService,
    private acmicService: AcmicService, 
    private datePipe: DatePipe) { }
  
  setEnrollData(data) {
    this.enrollData.next(data);
  }
  getEnrollData() {
    return this.enrollData.asObservable();
  }

  getInputs() {
    const inputs: FormBase<any>[] = [
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'addPolicyOnSignUp',
        label: 'POLICY_NUMBER_SIGNUP',
        required: true,
        type: 'text',
        maxLength: this.acmicService.isACMIC() ? 13 : 14,
        minLength: 6,
        placeholder: 'e.g. 1234567890',
        validationMessageError: 'ENTER_VALID_POLICY_NUMBER_MESSAGE',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'signUpFirst_name',
        label: 'FIRST_NAME',
        required: true,
        type: 'text',
        placeholder: 'Name',
        validationMessageError: this.acmicService.isACMIC()
          ? 'VALID_NAME_VALIDATION_MESSAGE'
          : 'ENTER_VALID_FIRST_NAME',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'signUpLast_name',
        label: 'LAST_NAME',
        required: true,
        type: 'text',
        placeholder: 'Last name',
        validationMessageError: this.acmicService.isACMIC()
          ? 'VALID_NAME_VALIDATION_MESSAGE'
          : 'ENTER_VALID_LAST_NAME',
      }),
      new TextBox({
        additionalClasses: `${Constants.FORM_CONTROL} date`,
        inputType: 'date',
        key: 'enrollDob',
        label: 'DOB',
        minLength: 10,
        maxLength: 10,
        min: '',
        max: this.fbs.getCurrentDate(),
        required: true,
        type: 'dob',
        hasCallenderCustomIcon: true,
        placeholder:'mm/dd/yyyy',
        validationMessageError: 'ENTER_VALID_DOB_VALIDATION_MESSAGE',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'noPhoneEmail_zipcode',
        label: 'ZIP Code',
        minLength: 5,
        maxLength: 5,
        required: true,
        type: 'number',
        placeholder:'e.g. 12345',
        validationMessageError: 'ENTER_VALID_ZIPCODE',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'email',
        key: 'createAc_email',
        label: 'EMAIL',
        minLength: 5,
        required: true,
        type: 'email',
        placeholder:'e.g. users@mail.com',
        validationMessageError: 'VALID_EMAIL_VALIDATION_MESSAGE',
      })
    ];
    return inputs;
  }

  getEnrollDetails(enrollData): EnrollData[] {
    return [
      {
        type: "Policy number:",
        val: enrollData?.policyNumber
      },
      {
        type: "First name:",
        val: enrollData?.user?.firstName
      },
      {
        type: "Last name:",
        val: enrollData?.user?.lastName
      },
      {
        type: "Date of birth:",
        val: this.datePipe.transform(enrollData?.user?.dateOfBirth, Constants.DATE_MM_DD_YYYY)
      },
      {
        type: "ZIP Code:",
        val: enrollData?.user?.zipCode
      },
      {
        type: "Email:",
        val: enrollData?.user?.email?.email
      }
    ]
  }
  getDateInMMDDYYYYFormat(date) {
    const splitDate = date.split('-');
    const month = splitDate[1];
    const day = splitDate[2];
    const year = splitDate[0];
    return `${month}/${day}/${year}`;
  }
  enrollPaperless(retryAttemt, payload, policyNumber): Observable<any> {
    const payloadData = Object.assign({}, payload);
    payloadData.dateOfBirth = this.getDateInMMDDYYYYFormat(payloadData.dateOfBirth);
    const url = `${environment.backend_server_url_account}/guest/${policyNumber}/paperless?retryAttempt=${retryAttemt}`;
    return this.http.post(url, payloadData);
  }
}
interface EnrollData  {
  type: string;
  val: string;
}
